import { streamSSE } from "@/lib/stream-sse";

import type { SMSTemplateRequest } from "@/types/ai";

import { kyInstance } from "@/api/api-config";

/**
 * Streams AI-generated SMS template from the backend.
 */
export async function* streamSMSTemplate(
  request: SMSTemplateRequest,
  signal?: AbortSignal,
): AsyncGenerator<string, void, unknown> {
  const response = await kyInstance.post("ai/sms/template", {
    json: request,
    signal,
  });

  for await (const chunk of streamSSE(response, {
    signal,
    errorMessage: "Failed to generate SMS template",
  })) {
    // Filter out summary events, only yield strings
    if (typeof chunk === "string") {
      yield chunk;
    }
  }
}
